/* eslint-disable no-console */
// Desc: Admin Overview page
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import { httprequest } from "../../../data/api";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react/dist/iconify.js";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import Badge from "../../../components/Badge";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";
import { useWard } from "../../../context/GaurdianContext";
import useStyles from "../styles";
import Button from "../../../components/Button";
import InputGroup from "../../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import Select from "react-select";
import { Grid } from "@mui/material";
import Modal from "../../../components/Modal";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const STUDENT_TRANSACTIONS = "/api/v1/invoices/student-invoices/students";
const MAKE_PAYMENT = "/api/v1/invoices/student-invoices";
const UPLOAD_ENDPOINT = "/api/v1/upload";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    if (!error.message?.includes("toggle") && !error.stack?.includes("typedCharts")) {
      console.log("Error caught by boundary:", error);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.error?.message?.includes("toggle") ||
            this.state.error?.stack?.includes("typedCharts")) {
        return this.props.children;
      }

      return this.props.fallback;
    }

    return this.props.children;
  }
}
const AdminOverview = () => {
  const navigate = useNavigate();
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [payemntOverview, setAllPaymentOverview] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [getIsLoading, setGetIsLoading] = useState(false);
  const width = useWindowSize();
  const { selectedWard } = useWard();
  const classes = useStyles();
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [comment, setComment] = useState("");
  const [isProcessingOfflinePayment, setIsProcessingOfflinePayment] = useState(false);
  const [receiptData, setReceiptData] = useState({
    title: "",
    file: null
  });

  const paymentMethods = [
    { value: "bank_transfer", label: "Bank Transfer" },
    { value: "cash", label: "Cash" }
  ];
  /**
 * State for managing item form data.
 * @typedef {Object} ItemFormState
 * @property {string} status - The status of the item.
 * @property {string} fee_option - The fee option for the item.
 * @property {string} item - The item name or description.
 */

  /**
 * Determines if the current viewport is mobile sized.
 * @type {boolean}
 */
  const isMobile = width < 600;

  /**
 * Fetches all terms for a specific session.
 * @function
 * @param {string} Session_ID - The ID of the session to get terms for.
 */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
 * Fetches payment overview data for a specific term.
 * @function
 * @param {string|number} aselectedTerm - The ID of the term to get overview for.
 */
  const getOverview = (term_id) => {
    setGetIsLoading(true);
    httprequest
      .get(`${STUDENT_TRANSACTIONS}/${selectedWard?.id}/transactions?term_id=${term_id}`)
      .then((res) => {
        setAllPaymentOverview(res?.data?.data);
        setSearchResult(res?.data?.data);
        setGetIsLoading(false);
      }).catch((err) => {
        setGetIsLoading(false);
        toast.error(err?.response?.message);
      });
  };

  const processOfflinePayment = async () => {
    if (!selectedInvoice?.invoice_no) {
      toast.error("Invoice information is missing");

      return;
    }

    if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
      toast.error("Please enter a valid payment amount");

      return;
    }

    if (selectedPaymentMethod?.value === "bank_transfer" && !receiptData.file) {
      toast.error("Please upload a receipt for bank transfer");

      return;
    }

    setIsProcessingOfflinePayment(true);

    try {
      const formData = new FormData();
      formData.append("file", receiptData.file);

      const uploadResponse = await httprequest.post(UPLOAD_ENDPOINT, formData);

      if (uploadResponse.status === 200 && uploadResponse.data.data) {
        const upload_id = uploadResponse.data.data[0]?.upload_id;
        const file_url = uploadResponse.data.data[0]?.file_url;

        const paymentPayload = {
          amount: parseFloat(paymentAmount),
          reference: `invoice-${selectedInvoice.invoice_no}-${Date.now()}`,
          payment_method: selectedPaymentMethod?.label || "Bank Transfer",
          description: comment || `Payment for invoice ${selectedInvoice.invoice_no}`,
          receipts: [
            {
              file_url,
              upload_id
            }
          ]
        };

        const paymentResponse = await httprequest.post(
          `${MAKE_PAYMENT}/${selectedInvoice.invoice_no}/transactions`,
          paymentPayload
        );

        toast.success(paymentResponse?.data?.message || "Payment submitted successfully!");
        setShowPaymentMethodModal(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Payment submission failed");
    } finally {
      setIsProcessingOfflinePayment(false);
    }
  };

  const handleMakePaymentClick = (invoice) => {
    setSelectedInvoice(invoice);
    setShowPaymentMethodModal(true);
    setSelectedPaymentMethod("");
  };

  const handlePaymentMethodSelect = () => {
    // eslint-disable-next-line no-console
    console.log("upload qoring");
    processOfflinePayment();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
      if (!validTypes.includes(file.type)) {
        toast.error("Please select a JPG, PNG, or PDF file");

        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        toast.error("File size must be less than 10MB");

        return;
      }

      setReceiptData(prev => ({
        ...prev,
        file
      }));
    }
  };

  const handleRemoveFile = () => {
    setReceiptData(prev => ({
      ...prev,
      file: null
    }));
  };
  const handleAmountChange = (e) => {
    console.log("Amount change triggered"); // Debug log
    e.preventDefault();
    e.stopPropagation();

    const value = e.target.value;
    const rawValue = value.replace(/,/g, "");
    if (rawValue === "" || /^\d*\.?\d*$/.test(rawValue)) {
      console.log("Setting payment amount to:", rawValue); // Debug log
      setPaymentAmount(rawValue);
    }
  };

  const formatAmountWithCommas = (value) => {
    if (!value) return "";
    const numberValue = value.toString().replace(/,/g, "");

    return numberValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  /**
 * Fetches all sessions from the server.
 * @async
 */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * The active term in the current session.
 * @type {Object}
 */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
 * Handles session change events.
 * @function
 * @param {Object} e - The event object from the select input.
 */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };
    /**
           * @description When active_term_session changes, updates the selected term state.
           * @deps active_term_session
           */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
    }
  }, [active_term_session]);

  /**
 * Handles term change events.
 * @function
 * @param {Object} event - The event object from the select input.
 */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    getOverview(selectedTermId);
  };

  /**
 * Column definitions for the data table.
 * @type {Array<Object>}
 * @property {string} name - The column header name.
 * @property {Function} selector - Function to render cell content.
 * @property {boolean} [center] - Whether to center the column content.
 * @property {Function} [cell] - Alternative render function for cells.
 */
  const columns = [
    {
      name: "Invoice Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice Name</p>}
          {row?.invoice_name || "--/--"}
        </>
      )
    },
    {
      name: "Invoice NO",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice NO</p>}
          {row?.invoice_no || "--/--"}
        </>
      )
    },
    {
      name: "Amount Paid",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount Paid</p>}
          {(row?.amount || 0)?.toLocaleString()}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column", margin: 0, marginBlock: 0 }}>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row?.status} />
        </p>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => navigate(`/guardian/transaction/${row?.id}`)}>
            <Icon icon="fluent:eye-16-regular" />
          </button>
          {row?.status !== "approved" && (
            <button
              className="table-action-icon"
              onClick={() => handleMakePaymentClick(row)}
            >
              <Icon icon="icon-park-outline:upload-two" />
            </button>
          )}
        </div>
      )
    }
  ];

  /**
 * Handles student search functionality.
 * @function
 * @param {Object} e - The event object from the search input.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    if (!value) {
      setSearchResult(payemntOverview);

      return;
    }

    const valArray = value.split(" ");

    const result = payemntOverview?.filter((data) => valArray?.every(
      (word) => data?.invoice_name?.toLowerCase().includes(word.toLowerCase()) ||
        data?.invoice_no?.toLowerCase().includes(word.toLowerCase()) ||
        data?.status?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    const originalConsoleError = console.error;
    console.error = (...args) => {
      if (args[0] && typeof args[0] === "string") {
        if (args[0].includes("toggle") ||
            args[0].includes("typedCharts") ||
            args[0].includes("The above error occurred")) {
          return;
        }
      }
      originalConsoleError.apply(console, args);
    };

    return () => {
      console.error = originalConsoleError;
    };
  }, []);

  /**
 * @effect
 * @description On component mount, fetches all classes, sessions, and terms.
 */
  useEffect(() => {
    getAllSessions();
    getAllTerms();
  }, []);

  /**
 * @description When active_term_session changes, updates the selected term and fetches overview data.
 * @deps active_term_session
 */
  useEffect(() => {
    if (selectedWard?.id && aselectedTerm) {
      getOverview(aselectedTerm);
    }
  }, [selectedWard?.id, aselectedTerm]);

  /**
 * @effect
 * @description When activeSession changes, fetches all terms for the active session.
 */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  return (
    <>
      <ErrorBoundary>
        <Layout children={
          <>
            <PageTitle
              title="Transaction History"
              subtitle="View receipt sent from the school"
            />

            <div className="flex gap-10 align-items-end margin-top-5 margin-bottom">
              <div>
                {activeSession?.id && (
                  <SelectGroup
                    children={
                      <select
                        defaultValue={activeSession?.id}
                        onChange={handleSessionChange}
                        name="session"
                      >
                        <option value="">---Select---</option>
                        {allSessions?.map((sesh) => {
                          return (
                            <option key={sesh?.id} value={sesh?.id}>
                              {sesh?.session}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                )}
              </div>
              <div>
                {active_term_session?.id && (
                  <SelectGroup
                    children={
                      <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                        <option value="">---Select---</option>
                        {selectedSessionTerms?.map((data) => {
                          return (
                            <option key={data?.id} value={data?.id}>
                              {data?.term}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                )}
              </div>
            </div>
            {/* <div className={classes.infocontainer}>
          <p className={classes.infotitle}>Information:</p>
          <p className={classes.infotext}>
        The School admin has asked for more information on
            <span className={classes.invoice}> 1209233-dasj </span>
            <span className={classes.infolink}>Click here</span> to continue
          </p>
        </div> */}

            <div className="page-content margin-top-30">
              <>
                {getIsLoading ? (
                  <PageLoader />
                ) : (
                  <Table
                    data={searchResult}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      <div className="action_div">
                        <TableSearch
                          placeholder="Search here..."
                          searchTableFunc={handleSearchStudent}
                        />
                      </div>}
                  />
                )}
              </>
            </div>

            <Modal
              title="Upload Receipt"
              subtitle="Select payment method and provide payment details"
              modalContent={
                <Grid container spacing={2} className="input-padding">
                  <Grid item xs={12}>
                    <InputGroup
                      label="Invoice No"
                      inputType="text"
                      inputName="invoice_no"
                      value={selectedInvoice?.invoice_no ? `#${selectedInvoice.invoice_no}` : "--/--"}
                      placeHolder="Invoice No"
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <InputGroup
                      label="Amount Paid"
                      inputType="text"
                      inputName="amount"
                      placeHolder="Enter amount"
                      value={formatAmountWithCommas(paymentAmount)}
                      onChange={handleAmountChange}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <div className="multiple-select">
                      <p>Select Payment Method</p>
                      <Select
                        label="Payment Method"
                        options={paymentMethods}
                        value={selectedPaymentMethod}
                        onChange={(selectedOption) => setSelectedPaymentMethod(selectedOption)}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 })
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="absolute"
                        menuShouldScrollIntoView={false}
                        isSearchable={false}
                      />
                    </div>
                  </Grid>

                  {(selectedPaymentMethod?.value === "bank_transfer" || selectedPaymentMethod?.value === "cash") && (
                    <Grid item xs={12}>
                      <p className="text-align-left no-margin-block">
                        <strong>Upload Receipt</strong>
                        <span className="input-required">*</span>
                      </p>
                      <div className={classes.pickcontainer}>
                        <input
                          type="file"
                          required
                          className={classes.picker}
                          onChange={handleFileChange}
                          name="file"
                          accept=".png, .jpg, .jpeg, .pdf"
                        />

                        <div className={classes.uploadflex}>
                          <div>
                            <Icon
                              icon="icon-park-outline:upload-two"
                              className={classes.uploadicon}
                            />
                          </div>
                          {receiptData.file?.name ? (
                            <div>
                              <h2 className={classes.uploadtitle}>
                                {receiptData.file?.name}
                              </h2>
                              <p className={classes.uploadsubtitle}>
                                {(receiptData.file.size / (1024 * 1024)).toFixed(2)} MB
                              </p>
                            </div>
                          ) : (
                            <div>
                              <p className={classes.uploadtitle}>
              Tap to Upload
                              </p>
                              <p className={classes.uploadsubtitle}>
              JPG, PNG, PDF | 10MB max.
                              </p>
                            </div>
                          )}
                        </div>
                        <div className={classes.rightpicker}>
                          {receiptData.file?.name && (
                            <div
                              className={classes.uploadbutton}
                              onClick={handleRemoveFile}
                            >
                              <Icon icon="zondicons:minus-solid" /> Remove File
                            </div>
                          )}
                        </div>
                      </div>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <TextAreaGroup
                      label="Comment (Optional)"
                      inputName="comment"
                      margin="normal"
                      placeholder="Add any additional comments about this payment"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    />
                  </Grid>
                </Grid>
              }
              modalFooter={
                <div className="flex gap-10">
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName={isProcessingOfflinePayment ? "Processing..." : "Submit Payment"}
                    onClick={handlePaymentMethodSelect}
                  />
                </div>
              }
              isopen={showPaymentMethodModal}
              closeModal={() => {
                setShowPaymentMethodModal(false);
                setPaymentAmount("");
                setComment("");
                setReceiptData({ title: "", file: null });
                setSelectedPaymentMethod("");
              }}
            />
          </>
        }
        />
      </ErrorBoundary>
    </>
  );
};

export default AdminOverview;
